import { useEffect, useState } from "react";
import InteressadoService from "../../../../services/InteressadoService";
import { Autocomplete } from "@material-ui/lab";
import { CircularProgress, TextField } from "@material-ui/core";
import { cpfCnpj } from "../../../../functions";

export default function PesquisaInteressados({ value, setValue, error, processos, disabled, permiteMaisDeUm }) {
    const [open, setOpen] = useState(false)
    const [options, setOptions] = useState([])
    const [pesquisandoInteressado, setPesquisandoInteressado] = useState(false)

    const loading = open && pesquisandoInteressado

    const BuscaInteressado = async (cpfOuCNPJ) => {
        let listaInteressado = [];
        if (processos !== undefined && processos.length > 0) {
            processos.forEach(processo => {
                processo.interessados.forEach(interessado => {
                    let interessaoOpcao = {
                        pessoaId: interessado.pessoaId,
                        nome: interessado.nome,
                        cpfCnpj: interessado.cpfCnpj,
                    }

                    var interessadoJaIncluido = listaInteressado.filter(item => {
                        return item.pessoaId === interessaoOpcao.pessoaId
                    });

                    if (interessadoJaIncluido.length === 0) {
                        if (interessaoOpcao.pessoaId !== 0) {
                            listaInteressado.push(interessaoOpcao)
                        }
                    }
                })
            })
        }

        if (listaInteressado.length > 0) {
            setOptions(listaInteressado)
            return
        }

        setPesquisandoInteressado(true)
        InteressadoService.ConsulteNomeCpfCnpj(cpfOuCNPJ)
            .then(response => {
                let insteressadosLocalizados = [];
                response.data.forEach(data => {
                    const interessado = {
                        ...data,
                        pessoaId: data.idPessoa,
                        nome: data.nomeInteressado,
                        cpfCnpj: data.cpFouCNPJ,
                    }

                    if (data.idPessoa !== 0) {
                        insteressadosLocalizados.push(interessado)
                    }
                })

                setOptions(insteressadosLocalizados)
                setPesquisandoInteressado(false)
            })
            .catch(() => {
                setOptions([])
                setPesquisandoInteressado(false)
            })
    }

    useEffect(() => {
        if (!loading) {
            return undefined
        }
    }, [loading])

    useEffect(() => {
        if (!open) {
            setOptions([])
        }
    }, [open])

    return (
        <Autocomplete
            multiple
            open={open}
            onOpen={() => {
                setOpen(true)
            }}
            onClose={() => {
                setOpen(false)
            }}
            value={value}
            onChange={(event, newValue) => {
                const interessadosSelecionados = [];

                newValue.reduce((novoInteressado, interessadoAtual) => {
                    if (novoInteressado.indexOf(interessadoAtual.nome) === -1) {
                        novoInteressado.push(interessadoAtual.nome);
                        if (interessadosSelecionados.length === 0 ||
                            permiteMaisDeUm === undefined ||
                            permiteMaisDeUm === true) {

                            interessadosSelecionados.push(interessadoAtual);
                        }
                    }

                    return novoInteressado;
                }, []);

                setOptions([]);
                setValue(interessadosSelecionados);
            }}
            getOptionLabel={(option) => `${option.nome} ${option.cpfCnpj === null ? "" : `- ${cpfCnpj(option.cpfCnpj)}`}`}
            options={options}
            loading={loading}
            loadingText="Carregando dados..."
            noOptionsText="Nenhum resultado encontrado"
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder="Digite o Nome, CPF ou CNPJ do interessado"
                    label="Interessados"
                    variant="outlined"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress style={{ color: 'var(--primary)' }} size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                    onChange={event => BuscaInteressado(event.target.value)}
                    error={error ? error.errorState : false}
                    helperText={error ? error.errorHelperText : ""}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            )}
            disabled={disabled}
        />
    )
}